import * as actionTypes from './actionTypes';
import axios from 'axios';
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const recalculate = (id, token) => async dispatch => {
   dispatch({
      type: actionTypes.RECALCULATE_START
   });
   const options = {
      url: `${api}/bets/${id}/activeBets`,
      method: 'POST',
      headers: {
         'Authorization': `Bearer ${token}`
      },
   }
   await axios(options)
      .then(response => dispatch({
         type: actionTypes.RECALCULATE_SUCCESS,
         payload: response.data
      }))
      .catch(error => dispatch({
         type: actionTypes.RECALCULATE_FAIL,
         payload: getMessage(error)
      }))
}